import React, { Component } from 'react';
import './BankSnapshot.scss';
import BankStatus from '../BankStatus/BankStatus';
import { BANK_STATUS } from '../../../settings/settings';
import If from '../../Shared/If/If';
import { hasValue } from '../../../utils/utils';
import { MdExpandMore } from 'react-icons/md/index';

class BankSnapshot extends Component {
  addCustomStyle = () => {
    const { isSingleBank, isMultipleBank, isReview, isRecurringReview } =
      this.props;
    const classes = ['bank-snapshot'];
    if (isSingleBank) {
      classes.push('bank-snapshot-single-bank');
    }
    if (isMultipleBank) {
      classes.push('bank-snapshot-multiple-bank');
    }
    if (isReview) {
      classes.push('bank-snapshot-review');
    }
    if (isRecurringReview) {
      classes.push('bank-snapshot-recurringReview');
    }
    return classes.join(' ');
  };

  isSingleBankWithMicroDeposits() {
    const { bank, isSingleBank } = this.props;
    return (
      isSingleBank &&
      (bank.bankStatus === BANK_STATUS.PREPARING_MICRO_DEPOSITS ||
        bank.bankStatus === BANK_STATUS.VERIFY_MICRO_DEPOSITS)
    );
  }

  render() {
    const { bank, editMode, isRecurringReview, isReview, toggleEdit } =
      this.props;
    const { accountNumber, bankAccountType, name, registrationLines } = bank;
    const customStyles = this.addCustomStyle();
    const singleBankWithMicroDeposits = this.isSingleBankWithMicroDeposits();
    return (
      <div>
        <div
          title={`${name} - ${bankAccountType} ${accountNumber} `}
          className={customStyles}
        >
          <div
            className={`bank-snapshot-displayName ${
              singleBankWithMicroDeposits
                ? 'bank-snapshot-displayNameSingleBank'
                : ''
            }`}
          >
            <span
              className={`bank-snapshot-name ${
                isRecurringReview ? 'bank-snapshot-recurringName' : ''
              } e2e-bank-snap-name`}
            >
              {name}
            </span>
            <span className="bank-snapshot-type e2e-bank-snap-type">
              {' '}
              &mdash; {bankAccountType}
            </span>
            <span className="bank-snapshot-number e2e-bank-snap-number blocked_data">
              {accountNumber}
            </span>

            <BankStatus
              bankStatus={bank.bankStatus}
              accountNumber={accountNumber}
              bank={bank}
            />
          </div>

          <If test={hasValue(registrationLines)}>
            <div className="bank-snapshot-owner-names e2e-bank-snap-owner-names blocked_data">
              {registrationLines && registrationLines.join(', ')}
            </div>
          </If>
        </div>
        <If test={!editMode && !isReview}>
          <div className="bank-snapshot-edit-icon">
            <span
              id="bank-snapshot-select-diff-bank"
              className="bank-snapshot-drop-down-cursor college-branded-link"
              onClick={toggleEdit}
            >
              Choose a different bank <MdExpandMore />
            </span>
          </div>
        </If>
        <If test={editMode}>
          <div className="bank-snapshot-underline" />
        </If>
      </div>
    );
  }
}

export default BankSnapshot;
